import React from 'react';

export default {
  width: 16,
  height: 16,
  content: (
    <path d="M15.262 16h-4.15V9.946h2.11l.32-2.595h-2.43V6.002c0-.692.19-1.245 1.212-1.245h1.454V2.694c-.445-.03-1.134-.095-2.036-.095-1.875 0-3.298 1.116-3.298 3.165v1.587H6.222v2.595h2.222V16H.747C.249 16 0 15.684 0 15.2V1.077C0 .592.249 0 .747 0h14.515c.494 0 .738.592.738 1.077V15.2c0 .484-.244.8-.738.8z" />
  )
};
